import { useTranslation } from "@redotech/redo-i18n";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";
import { Text } from "../../../../text";

export const DpdNlCarrierInput = groupInput({
  username: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
});

export type DpdNlCarrierValue = InputSchema.Value<typeof DpdNlCarrierInput>;

export type DpdNlCarrierForm = InputSchema.Input<typeof DpdNlCarrierInput>;

export const dpdNlCarrierDefault = (): DpdNlCarrierValue => ({
  username: "",
  password: "",
});

export const CreateDpdNlCarrierForm = memo(function CreateDpdNlCarrierForm({
  carrierInput,
}: {
  carrierInput: DpdNlCarrierForm;
}) {
  const { t } = useTranslation();
  return (
    <Flex dir="column">
      <RedoTextInput
        label={t("Delis ID")}
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
      <RedoTextInput
        inputTypeHint="password"
        label={t("Password")}
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
      <Text fontSize="xs" textColor="secondary">
        {t(
          "DPD NL does not share prices with Redo. After you connect this account, contact Redo to add your DPD NL rate card. Return rates from this account are offered only once the rate card is in place.",
        )}
      </Text>
    </Flex>
  );
});
